import { IRenderingCommonContext } from "@commonRendering/types";
import { WidgetRendererBase } from "../../widget-renderer-base";
import { CalendarEventDetailsWidgetData, ICalendarEventDetailsWidgetData, ICalendarEventDetailsWidgetShortData } from "src/typings/calendar/calendar-event-details-widget-data";
import { CalendarEventDetailsWidgetScriptRenderer } from "./calendar-event-details-widget-script-renderer";
import { CalendarEventDetailsWidgetStyleRenderer } from "./calendar-event-details-widget-style-renderer";
import { Base64Util } from "src/utils/base64-util";

export class CalendarEventDetailsWidgetRenderer extends WidgetRendererBase<ICalendarEventDetailsWidgetData> {

    private readonly scriptRenderer: CalendarEventDetailsWidgetScriptRenderer;
    private readonly styleRenderer: CalendarEventDetailsWidgetStyleRenderer;

    constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);

        this.scriptRenderer = new CalendarEventDetailsWidgetScriptRenderer();
        this.styleRenderer = new CalendarEventDetailsWidgetStyleRenderer(this.styleService);
    }

    protected override renderInternal(element: HTMLElement, data: ICalendarEventDetailsWidgetData): HTMLElement {
        this.setAttributes(element, data);
        this.renderStyles(element, data);
        this.renderScripts(element, data);

        return element;
    }

    private setAttributes(element: HTMLElement, data: ICalendarEventDetailsWidgetData): void {
        if (this.isEditorRendering) {
            element.dataset.draft = "true";
        }

        if (data.eventModelBase64) {
            element.dataset.eventModel = data.eventModelBase64;
        }

        element.dataset.data = Base64Util.serialize(this.getShortData(data)) || "";
        element.toggleAttribute("data-primary-element", data.primaryElement);
    }

    private getShortData(data: ICalendarEventDetailsWidgetData): ICalendarEventDetailsWidgetShortData {
        return {
            style: {
                buttonTheme: data.style.button?.theme
            }
        };
    }

    private renderScripts(element: HTMLElement, data: ICalendarEventDetailsWidgetData): void {
        this.scriptRenderer.renderCommon(this.renderedDocument);

        const previousData = this.getData(element);
        if (CalendarEventDetailsWidgetData.isLocalScriptRerenderNeeded(previousData, data)) {
            this.scriptRenderer.renderLocal(element);
        }
    }

    protected override createNewInternal(): HTMLElement {
        return this.createWidgetElement("calendarEventDetailsWidget");
    }

    protected override renderStyles(element: HTMLElement, data: ICalendarEventDetailsWidgetData): void {
        this.animationRenderer.setAnimationStyles(element, data.style.animation);
        this.styleRenderer.render(element, data.style);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override cleanupInternal(element: HTMLElement): void {
        // do nothing
    }

    protected override getContentSelectorsInternal(element: HTMLElement): Array<string> {
        return this.styleRenderer.getContentSelectors(element);
    }

}
